import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Flame } from "lucide-react";
import api from "@/lib/api";

export default function SocialProof({ variant = "light", showPosition = false, className = "" }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const res = await api.get("/social-proof");
        if (active) setData((prev) => (prev && res.data.today < prev.today ? prev : res.data));
      } catch (_) { /* silenzioso */ }
    };
    load();
    const t = setInterval(load, 45000);
    return () => { active = false; clearInterval(t); };
  }, []);

  if (!data) return null;
  const dark = variant === "dark";

  return (
    <motion.div data-testid="social-proof" initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }}
      className={`inline-flex items-center gap-2.5 rounded-full px-4 py-2 ${className}
        ${dark ? "bg-white/12 text-white" : "bg-[#C17F59]/10 text-[#2D2825]"}`}>
      <motion.span animate={{ scale: [1, 1.18, 1] }} transition={{ duration: 1.6, repeat: Infinity }}>
        <Flame className={`h-4 w-4 ${dark ? "text-white" : "text-[#C17F59]"}`} />
      </motion.span>
      <span className="text-sm">
        <strong data-testid="social-proof-count" className="tabular-nums">{data.today.toLocaleString("it-IT")}</strong>{" "}
        analisi del viso completate oggi
        {showPosition && (
          <span className={dark ? "text-white/75" : "text-[#7A7571]"}> · la tua è la n° {data.position.toLocaleString("it-IT")}</span>
        )}
      </span>
    </motion.div>
  );
}
